import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionService } from './session.service';
import { SpinnerService } from './spinner.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';



@Injectable()
export class DbService {

    private url_services  : string = window.location.origin.indexOf('localhost') !== -1 ? "http://localhost:55329/api/" : "/service/api/";
    private   url_Cep     : string = "https://";
      
    exibe_spinner: boolean = true;

    constructor(
        private http: HttpClient,
        private sessionService: SessionService,
        private spinnerService: SpinnerService,
        private router: Router,
    ) { }

    private httpOptionsCep = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    get(url: string): Observable<any>;
    get<T>(url: string): Observable<T>;
    get(url: string): Observable<any> {
        if (this.exibe_spinner) {
            this.spinnerService.start();
        }

        return this.http.get(this.url_services + url).pipe(
            catchError((err) => {
                // Não trata 401 automaticamente no get, deixa o componente tratar
                console.error('Erro na requisição GET:', err);
                return throwError(err);
            }),
            finalize(() => this.spinnerService.stop())
        );
    }

    // GET em segundo plano: sem spinner e sem redirecionar em caso de erro (quem chama decide).
    getSilencioso(url: string): Observable<any> {
        const headers = new HttpHeaders({
            'Hash': this.sessionService.usuario.hash,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        });

        return this.http.get(this.url_services + url, { headers });
    }

    post(url: string, parametros: any): Observable<ApiResponse>;
    post<T>(url: string, parametros: any): Observable<T>;
    post(url: string, parametros: any): Observable<ApiResponse> {

        if (this.exibe_spinner) {
            this.spinnerService.start();
        }

        let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Hash': this.sessionService.usuario.hash });

        return this.http.post(this.url_services + url, parametros, { headers })
            .pipe(
                catchError((err) => {
                    if(err.status == 401){
                        this.router.navigate(['/home']);
                        this.sessionService.sessaoDupla = true;
                    }
                    return throwError(err);
                }),
                finalize(() => this.spinnerService.stop())
            );
    }

    postFile(url: string, parametros: any): Observable<any> {

        
        let headers = new HttpHeaders({ 'Accept': 'application/json', 'Hash': this.sessionService.usuario.hash });

        return this.http.post(this.url_services + url, parametros, { headers })
            .pipe(
                catchError((err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/login']);
                        this.sessionService.sessaoDupla = true;
                    }
                    return throwError(err);
                })
            );
    }

    put(url: string, parametros: any): Observable<any> {
        if (this.exibe_spinner) {
            this.spinnerService.start();
        }

        let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Hash': this.sessionService.usuario.hash });

        return this.http.put(this.url_services + url, parametros, { headers }).pipe(
            finalize(() => this.spinnerService.stop())
        );
    }

    delete(url: string): Observable<any> {
        if (this.exibe_spinner) {
            this.spinnerService.start();
        }

        return this.http.delete(this.url_services + url).pipe(
            finalize(() => this.spinnerService.stop())
        );
    }

}
